export default __webpack_public_path__ + "static/media/ax.310c28a9.svg";